import { EMasterFiltersActionTypes, TMasterSubAgentPayload, TMasterTabsPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить табу для мастера (Мои чаты/Чаты сотрудников)
 */
export const setMasterActiveTab = actionGenerator<EMasterFiltersActionTypes.SetActiveTab, TMasterTabsPayload>(
  EMasterFiltersActionTypes.SetActiveTab,
);

/**
 * Установить выбранного мастером сотрудника
 */
export const selectSubAgent = actionGenerator<EMasterFiltersActionTypes.SelectSubAgent, TMasterSubAgentPayload>(
  EMasterFiltersActionTypes.SelectSubAgent,
);

/**
 * Сбросить выбранного мастером сотрудника
 */
export const unselectSubAgent = actionGenerator<EMasterFiltersActionTypes.UnselectSubAgent, void>(
  EMasterFiltersActionTypes.UnselectSubAgent,
);
